import { DependencyList, useEffect } from 'react';

export const useDebouncedEffect = (
  effect: () => void,
  deps: DependencyList,
  delayMs: number
) => {
  useEffect(() => {
    const id = window.setTimeout(effect, delayMs);
    return () => window.clearTimeout(id);
  }, [...deps, delayMs]);
};
